import { useEffect, useState } from "react";

// "Modo rápido": on phones and weak devices the decorative layers (drifting clouds, seasonal particles, confetti, big blur
// effects) are switched off, so the app runs smoother. Preference: "auto" (default), "lite" (always) or "full" (never).
const KEY = "perfMode";
const EVENT = "perfmodechange";

export const getPerfPreference = () => {
  try { return localStorage.getItem(KEY) || "auto"; } catch { return "auto"; }
};

// Phone-sized touch screen, a data-saver connection or a very low-memory device. screen.width is the real device width
// (window.innerWidth is the fixed 1280 px "desktop" width on phones).
export const looksLikeWeakDevice = () => {
  try {
    const touchSmall = window.screen && window.screen.width <= 900 && window.matchMedia("(pointer: coarse)").matches;
    const saveData = !!(navigator.connection && navigator.connection.saveData);
    const lowMemory = typeof navigator.deviceMemory === "number" && navigator.deviceMemory <= 2;
    return !!(touchSmall || saveData || lowMemory);
  } catch { return false; }
};

export const resolvePerfMode = () => {
  const pref = getPerfPreference();
  if (pref === "lite" || pref === "full") return pref;
  return looksLikeWeakDevice() ? "lite" : "full";
};

// Writes the mode on <html data-perf="..."> so CSS (src/lite.css) can switch the heavy effects off
export const applyPerfMode = () => {
  const mode = resolvePerfMode();
  document.documentElement.setAttribute("data-perf", mode);
  return mode;
};

export const setPerfPreference = (pref) => {
  try { localStorage.setItem(KEY, pref); } catch { /* private mode: it just won't be remembered */ }
  applyPerfMode();
  window.dispatchEvent(new Event(EVENT));
};

export function usePerfMode() {
  const [mode, setMode] = useState(resolvePerfMode);
  useEffect(() => {
    const update = () => setMode(resolvePerfMode());
    window.addEventListener(EVENT, update);
    window.addEventListener("storage", update);
    return () => { window.removeEventListener(EVENT, update); window.removeEventListener("storage", update); };
  }, []);
  return mode;
}
